<template>
  <div class="flex items-center flex-col">
    <h1 class="font-(family-name:--font-logo) text-xl text-center text-[#cedec2]"> COLLOR </h1>
    <div class="bg-golden-grass h-0.5 w-15"></div>
  </div>
</template>

<script setup lang="ts"></script>
